import { regionalBackground } from '@/mocks/images';
import { cities } from '@/mocks/homeData';

export default function RegionalSection() {
  return (
    <section id="regiao" className="relative w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={regionalBackground}
          alt="Paisagem do Oeste Catarinense"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/70 to-secondary-950/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-8 py-12 md:py-16 flex flex-col lg:flex-row items-center gap-10">
        {/* Left text */}
        <div className="flex-1 max-w-lg">
          <h2 className="text-background-50 text-2xl md:text-3xl font-bold mb-2 leading-tight">
            Oeste Catarinense,
          </h2>
          <p className="font-script text-primary-400 text-3xl md:text-4xl mb-4">
            lugar de oportunidades e qualidade de vida!
          </p>
          <p className="text-background-300 text-sm leading-relaxed mb-6">
            Acreditamos no potencial da nossa região e trabalhamos para conectar pessoas aos melhores imóveis e negócios.
          </p>
          <a
            href="/conheca-a-regiao"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-pin-line text-sm"></i>
            </span>
            CONHEÇA NOSSA REGIÃO
          </a>
        </div>

        {/* Right - Cities */}
        <div className="flex-shrink-0">
          <div className="grid grid-cols-3 gap-4 md:gap-6">
            {cities.map((city) => (
              <div
                key={city.name}
                className="flex flex-col items-center text-center group"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full border-2 border-background-400/60 text-background-200 group-hover:border-primary-400 group-hover:text-primary-400 transition-colors mb-2">
                  <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center">
                    <i className={`${city.icon} text-lg md:text-xl`}></i>
                  </span>
                </div>
                <span className="text-xs text-background-200 font-medium leading-tight">
                  {city.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
